// extracted by mini-css-extract-plugin
export default {"portfolio":"Portfolio_portfolio__DQqpU","text":"Portfolio_text__moCnV","wrapper":"Portfolio_wrapper__lZTVK","iframe":"Portfolio_iframe__DWfE3"};